import Flex from 'typescript-styled-flex'
import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const HeaderWrapper = styled(Flex as any)<IWithSize>`
  height: ${({ size }) => (size ? 50 * size : 50)}px;
  width: ${({ size }) => (size ? 325 * size : 325)}px;
  padding: 0px ${({ size }) => (size ? 18 * size : 18)}px;
`
export default HeaderWrapper
